import { Box, Button, Chip, Grid, Typography } from "@mui/material";
import React, { use, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import '../../../../shared/styles/style.css';
import OpeningHours from "./OpeningHours";
import { useWindowSize } from "../../../../shared/hooks/useWindowSize";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import env from "../../../../app/config/envHelper";
import ExtraInfoSkeleton from "../laoding_components/ExtraInfoSkeleton";
import { useGetWorkshopServicesQuery } from "../../../../app/store/api/workshopApi";

export default function ExtraInfo({ workshop, show }) {
    const { t, i18n } = useTranslation();
    const { data: services, isLoading:loading } = useGetWorkshopServicesQuery(workshop?.id);
    const [ showContactInfo, setShowContactInfo ] = useState(true);
    const { isMobile } = useWindowSize();
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (isMobile) {
            setShowContactInfo(false);
        } else {
            setShowContactInfo(true);
        }
        setInitialized(true);
    }, [isMobile]);

    const showContactInfoButtonClicked = () => {
        setShowContactInfo(!showContactInfo);
    }

    const headerStyle = {
        marginBottom: "12px",
        fontWeight: "bold"
    }

    const textStyle = {
        size: 'small',
        textColor: 'grey'
    }

    if (!initialized) {
        return <ExtraInfoSkeleton isMobile={isMobile} />;
    }

    if (!show) {
        return (<></>)
    } else {
        return (
            <Box className="workshop-extra-info">
                <Box className="workshop-extra-info-description">
                    <Typography component="p" sx={headerStyle} >
                        {t("workshop.description")}
                    </Typography>
                    <Typography variant="body1" component="p">
                        {workshop?.description}
                    </Typography>
                </Box>

                <Box className="workshop-extra-info-services">
                    <Typography component="p" sx={{...headerStyle, marginRight: '10px'}} >
                        {t("workshop.services")}
                    </Typography>
                    <Box>
                        {loading && (
                            <Typography variant="body2" component="p">
                                {t("common.loading")}
                            </Typography>
                        )}
                        {!loading && services && services.length > 0 && (
                            <Grid container spacing={1}>
                                {services.filter((service) => service.level !== "basic").map((service) => (
                                    <Grid item key={service.id}>
                                        <Chip
                                            label={service.name || service.translations?.[i18n.language]?.name || service.id}
                                            size={isMobile ? "small" : "medium"}
                                            sx={isMobile ? { fontSize: "0.7rem", height: "24px" } : undefined}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Box>
                </Box>

                <Box className="workshop-extra-info-brands">
                    {workshop?.exclBrands?.brands.length > 0 && (
                        <>
                            <Typography component="p" sx={{...headerStyle, marginTop: '12px'}} >
                                {t("workshop.exclusiveBrands")}
                            </Typography>
                            <Typography variant="body1" component="p">
                                {workshop?.exclBrands?.brands.join(', ')}
                            </Typography>
                        </>
                    )}
                    {workshop?.specialtyBrands?.brands.length > 0 && (
                        <>
                            <Typography component="p" sx={{...headerStyle, marginTop: '12px'}}>
                                {t("workshop.specializedBrands")}
                            </Typography>
                            <Typography variant="body1" component="p">
                                {workshop?.specialtyBrands?.brands.join(', ')}
                            </Typography>
                        </>
                    )}
                    {workshop?.brandRepresentations?.length > 0 && (
                        <>
                            <Typography component="p" sx={{...headerStyle, marginTop: '12px'}}>
                                {t("workshop.representedBrands")}
                            </Typography>
                            <Typography variant="body1" component="p">
                                {workshop?.brandRepresentations.join(', ')}
                            </Typography>
                        </>
                    )}
                </Box>
                { isMobile && (
                    <Button
                        onClick={showContactInfoButtonClicked} 
                        endIcon={
                            <ExpandMoreIcon
                                sx={{
                                    transform: showContactInfo ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.2s ease-in-out",
                                }}
                            />
                        }
                        sx={{
                            textTransform: "none",
                            textDecoration: "underline",
                            fontSize: "0.9rem",
                            color: "black",
                            "&:hover": {
                                background: "transparent",
                                textDecoration: "underline",
                            },
                            marginTop: '12px',
                        }}
                    >
                        {t("workshop.showContactInfo")}
                    </Button>
                ) }
                { showContactInfo && (
                    <Grid container spacing={1} className="workshop-extra-info-opening-and-contact">
                        <Grid item size={{xs: 12, sm: 6, md: 6, lg: 6}} className="workshop-extra-info-contact-info">
                            <Typography component="p" sx={headerStyle} >
                                {t("workshop.contactInfo")}
                            </Typography>
                            <Typography variant="caption" component="p" sx={{ color: 'grey.600', fontSize: '0.9rem' }}>
                                {workshop?.wwwPages}
                            </Typography>
                            <Typography variant="caption" component="p" sx={{ color: 'grey.600', fontSize: '0.9rem' }}>
                                {workshop?.email}
                            </Typography>
                            { workshop?.phone && (
                                workshop.phone.map((phone, index) => (
                                    <Typography variant="caption" component="p" sx={{ color: 'grey.600', fontSize: '0.9rem' }} key={index}>
                                        {phone.number} {phone.extraInfo != null && phone.extraInfo !== "" && `(${phone?.extraInfo})`}
                                    </Typography>
                                ))
                            )}
                        </Grid>
                        <Grid item size={{xs: 12, sm: 6, md: 6, lg: 6}} className="workshop-extra-info-opening-hours">
                            <Typography component="p" sx={headerStyle} >
                                {t("workshop.openingHours")}
                            </Typography>
                            <OpeningHours openingHours={workshop?.openingHours} />
                        </Grid>
                    </Grid>
                )}
                
            </Box>
        );
    }

    
}
